"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoveUSConfigure = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const useMoveUSConfigure = () => {
    const [config, setConfig] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST + "/move_us_config.json";
        const sub = (0, trade_utils_lib_1.requestWithRetry)(() => trade_utils_lib_1.ObservableUtils.get(url, null, { "Cache-Control": "max-age=0" }), {
            maxRetryCount: 2,
            name: "useMoveUSConfigure",
        }).subscribe((data) => {
            data && setConfig(data);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    return config;
};
exports.useMoveUSConfigure = useMoveUSConfigure;
